/*
These functions make sure WordPress
and Foundation play nice together.
*/

function myFunction() {
    // Get the text field
    var copyText = document.getElementById("myInput");
  
    // Select the text field
    copyText.select();
    copyText.setSelectionRange(0, 99999); // For mobile devices
  
     // Copy the text inside the text field
    navigator.clipboard.writeText(copyText.value);
  
    // Alert the copied text
    alert("Copied the text: " + copyText.value);
  }

jQuery(document).ready(function () { // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

    // Adds Flex Video to YouTube and Vimeo Embeds
    jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
        if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
            jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
        } else {
            jQuery(this).wrap("<div class='responsive-embed'/>");
        }
    });

    // Show color details on tap
    jQuery('.toggle-color, .color-left').click(function() {
        jQuery('.color-block-2022').not(jQuery(this).parents('.color-block-2022')).removeClass('showme');
        jQuery(this).parents('.color-block-2022').toggleClass('showme');
    });
});

jQuery(function ($) {
    var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
    $('li a').each(function () {
        if (this.href === path) {
            $(this).addClass('active');
        }
    });
});

function copyClip(event) {
    let txt_uid = event.target.getAttribute('data-txt');
    let tip_uid = event.target.getAttribute('data-tip');
    
    var copyText = document.getElementById(txt_uid);
    console.log(copyText.innerText);
    navigator.clipboard.writeText(copyText.innerText);

    var tooltip = document.getElementById(tip_uid);
    tooltip.innerHTML = "Copied: " + copyText.innerText;
}
  
function copyOut(event) {
    var tip_uid = event.target.getAttribute('data-tip');
    var tooltip = document.getElementById(tip_uid);
    tooltip.innerHTML = "Copy to clipboard";
}